import React from 'react';
import './Departments.css';
import { ourDepartments } from '../../assets/exports';
import { Link } from 'react-router-dom';

const Departments = () => {
  return (
    <section className="departments">
      <div className="departments-wrapper">
        <h2 className="departments-section-title">Our Departments</h2>
        <div className="departments-grid">
          {ourDepartments.map((dept, index) => (
            <Link to={`/${dept.link}`} key={index}>
            <div className="department-card">
              <div className="department-icon">{dept.icon}</div>
              <h3>{dept.title}</h3>
              <p>{dept.description}</p>
            </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Departments;